import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'abbreviateNumber',
  pure: true,
  standalone: false
})
export class AbbreviateNumberPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(
    value: number,
    currencyCode?: string,
    display: 'code' | 'symbol' = 'symbol',
    digitsInfo = '1.0-2',
    fractionSize = 2
  ): string {
    if (value == null) {
      return '';
    }

    const absValue = Math.abs(value);
    let suffix = '';
    let abbreviated = value;

    if (absValue >= 1e6) {
      abbreviated = value / 1e6;
      suffix = 'M';
    } else if (absValue >= 1e3) {
      abbreviated = value / 1e3;
      suffix = 'K';
    }

    // Format the abbreviated number with fixed decimals.
    const formattedNumber = abbreviated.toFixed(fractionSize);

    // If a currencyCode is provided, use Angular’s CurrencyPipe.
    if (currencyCode) {
      const formattedCurrency = this.currencyPipe.transform(
        parseFloat(formattedNumber),
        currencyCode,
        display,
        digitsInfo
      );
      return formattedCurrency
        ? formattedCurrency + suffix
        : formattedNumber + suffix;
    }

    return formattedNumber + suffix;
  }
}
